(() => {
	angular
		.module('main')
		.directive('deleteAppointmentModal', deleteAppointmentModal);

	deleteAppointmentModal.$inject = [];

	function deleteAppointmentModal() {
		return {
			restrict: 'E',
			scope: {
				delete: '&'
			},
			template: `
                    <div id="deleteModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                   <btn-close></btn-close>
                                    <h3 class="modal-title">Delete appointment</h3>
                                </div>
                                <div class="modal-body">
                                    <strong>
                                      Are you sure you would like to delete this appointment and reminders associated with it?
                                    </strong>
                                </div>
                                <div class="modal-footer modal-foot">
                                    <button class="btn btn-danger btn-lg" ng-click="delete()">Delete appointment</button>
                                    <button class="btn btn-default btn-lg" data-dismiss="modal">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
             `,
			replace: true,
			transclude: true,
			link(scope) {}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Modals/private/deleteAppointmentModal.js